import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';
@Injectable({
  providedIn: 'root',
})
export class CommonPagesService {
  userAccountsArray: any[] = [];
  userSitesArray: any[] = [];
  userSitesArrayCopy: any[] = [];
  paybevRoles: any[] = [];
  currentInvestorName: any = '';
  currentInvestorCompany: any = '';
  isInvestmentHisoryLoading: boolean = true;

  currentInvestorDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private _cS: CommonService, private message: NzMessageService) { }
  getRoles() {
    return this._cS.API_GET(EndPoints.GetRoles + `?roleType=2`, false);
  }
  //create edit user
  createUser(userBody: any) {
    return this._cS.API_POST(EndPoints.AddUser, userBody);
  }
  EditUser(userBody: any) {
    return this._cS.API_POST(EndPoints.EditUser, userBody);
  }
  getSuppliersForUser() {
    return this._cS.API_POST(EndPoints.GetSuppliersForUser, false);
  }
  UpdateProgramToStartingBalTransaction(reqBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateProgramToStartingBalTransaction,
      reqBody,
      false,
      {
        headers: hd,
      }
    );
  }
  GetStartingBalanceDetails(transactionsId: any) {
    return this._cS.API_GET(
      EndPoints.GetStartingBalanceDetails + `?TransactionsId=${transactionsId}`,
      false
    );
  }

  /*Programs*/
  getProgramBySite() {
    return this._cS.API_GET(EndPoints.GetProgramBySite, false);
  }

  /*Vendors*/
  updatePaymentDetails(requestBody: any) {
    return this._cS.API_POST(EndPoints.UpdatePayment, requestBody, false);
  }

  cancelPayment(cancelBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.CancelPayment, cancelBody, false, {
      headers: hd,
    });
  }

  /*Investors*/
  getInvestorTerms(investorId: any) {
    return this._cS.API_GET(
      EndPoints.GetInvestorTerms + `?InvestorId=${investorId}`,
      false
    );
  }
  GetInvestmentDescription() {
    return this._cS.API_GET(EndPoints.GetInvestmentDescription, false);
  }

  /*Investment*/
  scheduleInvestment(investmentData: any) {
    return this._cS.API_POST(EndPoints.ScheduleInvestment, investmentData);
  }
  getInvestmentById(id: any, qboSupplierId: any) {
    return this._cS.API_GET(
      EndPoints.GetInvestmentById +
      `?InvestmentId=${id}&QBOSupplierId=${qboSupplierId}`,
      false
    );
  }
  getSiteService(id: any) {
    return this._cS.API_GET(
      EndPoints.GetSiteService + `?supplierId=${id}`,
      false
    );
  }
  updateInvestment(investmentData: any) {
    return this._cS.API_POST(EndPoints.UpdateInvestment, investmentData);
  }
  SaveInvestment(investmentData: any) {
    return this._cS.API_POST(EndPoints.SaveInvestment, investmentData);
  }
  updateInvestmentRequest(investmentData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.EditInvestmentRequest,
      investmentData,
      false,
      {
        headers: hd,
      }
    );
  }
  cancelInvoice(cancelBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.CancelInvestment, cancelBody, false, {
      headers: hd,
    });
  }

  getInternalTransfer(internalTransferId: any) {
    return this._cS.API_GET(
      EndPoints.GetInternalTransfer + `?TransferId=${internalTransferId}`,
      false
    );
  }
  getExpense(expenseId: any) {
    return this._cS.API_GET(
      EndPoints.GetExpense + `?expenseID=${expenseId}`,
      false
    );
  }
  getRefund(refundsId: any) {
    return this._cS.API_GET(
      EndPoints.GetRefund + `?refundsId=${refundsId}`,
      false
    );
  }
  getCredit(creditId: any) {
    return this._cS.API_GET(
      EndPoints.GetCredit + `?CreditsId=${creditId}`,
      false
    );
  }
  getDeposit(depositId: any) {
    return this._cS.API_GET(
      EndPoints.GetDeposit + `?depositId=${depositId}`,
      false
    );
  }
  PreviewQBOAttachment(QBOAttachmentId: any) {
    return this._cS.API_GET(
      EndPoints.PreviewQBOAttachment + `?QBOAttachmentId=${QBOAttachmentId}`,
      false
    );
  }
  updateInternalTransfer(internalTransferBody: any) {
    return this._cS.API_POST(
      EndPoints.UpdateInternalTransfer,
      internalTransferBody,
      false
    );
  }
  updateExpense(expenseBody: any) {
    return this._cS.API_POST(EndPoints.UpdateExpense, expenseBody, false);
  }
  updateCredit(creditBody: any) {
    return this._cS.API_POST(EndPoints.UpdateCredit, creditBody, false);
  }
  updateRefund(refundBody: any) {
    return this._cS.API_POST(EndPoints.UpdateRefund, refundBody, false);
  }
  updateDeposit(depositBody: any) {
    return this._cS.API_POST(EndPoints.UpdateDeposit, depositBody, false);
  }

  changePassword(requestBody: any) {
    return this._cS.API_POST(EndPoints.ChangePassword, requestBody, false);
  }

  //delete transaction
  deletePayment(paymentId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeletePayment + `?paymentId=${paymentId}`
    );
  }
  deleteInvestment(formData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.DeleteInvestment, formData, false, {
      headers: hd,
    });
  }

  //message
  displayMessage(type: string, message: string) {
    this.message.create(type.toString(), message, { nzDuration: 7000 });
  }

  //Retail Program Investments
  addRetailProgramInvestment(investmentData: any) {
    return this._cS.API_POST(
      EndPoints.AddRetailProgramInvestment,
      investmentData
    );
  }
  updateRetailProgramInvestment(investmentData: any) {
    return this._cS.API_POST(
      EndPoints.UpdateRetailProgramInvestment,
      investmentData
    );
  }
  renewRetailProgramInvestment(investmentData: any) {
    return this._cS.API_POST(
      EndPoints.RenewRetailProgramInvestment,
      investmentData
    );
  }

  getSupplierInvestors(qboEntityId: string, programId: string) {
    return this._cS.API_GET(
      EndPoints.GetSupplierInvestors +
      `?qboEntityId=${qboEntityId}&retailProgramId=${programId}`,
      false
    );
  }

  AddLocalRep(requestBody: any) {
    return this._cS.API_POST(EndPoints.AddRep, requestBody, false);
  }
}
